import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import api from '../services/api';
import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGES,
  interpolate,
  translations,
} from './translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [selectedLanguage, setSelectedLanguage] = useState(DEFAULT_LANGUAGE);
  const [languages, setLanguages] = useState(FALLBACK_LANGUAGES);

  useEffect(() => {
    let active = true;

    api.getLanguages()
      .then(options => {
        if (active && Array.isArray(options) && options.length > 0) {
          setLanguages(options);
        }
      })
      .catch(() => {
        if (active) setLanguages(FALLBACK_LANGUAGES);
      });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = selectedLanguage;
  }, [selectedLanguage]);

  const value = useMemo(() => {
    const t = (key, values) => {
      const message =
        translations[selectedLanguage]?.[key] ??
        translations[DEFAULT_LANGUAGE]?.[key] ??
        key;

      return interpolate(message, values);
    };

    return {
      languages,
      selectedLanguage,
      setSelectedLanguage,
      t,
    };
  }, [languages, selectedLanguage]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used inside LanguageProvider');
  }
  return context;
}
